// Module
var code = "<!-- ko if: IsAuthenticated --> <div class=\"menu-toggler sidebar-toggler\"></div> <!-- /ko -->";
// Exports
export default code;